"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollParent = exports.cancelEvent = exports.EventListener = exports.Keys = void 0;
var Keys;
(function (Keys) {
    Keys["TAB"] = "Tab";
    Keys["ENTER"] = "Enter";
    Keys["ESC"] = "Escape";
    Keys["SPACE"] = " ";
    Keys["SPACEBAR"] = "Spacebar";
    Keys["PAGE_UP"] = "PageUp";
    Keys["PAGE_DOWN"] = "PageDown";
    Keys["HOME"] = "Home";
    Keys["END"] = "End";
    Keys["ARROW_LEFT"] = "ArrowLeft";
    Keys["ARROW_UP"] = "ArrowUp";
    Keys["ARROW_RIGHT"] = "ArrowRight";
    Keys["ARROW_DOWN"] = "ArrowDown";
    Keys["BACKSPACE"] = "Backspace";
})(Keys || (exports.Keys = Keys = {}));
var EventListener;
(function (EventListener) {
    EventListener["DOMMouseScroll"] = "DOMMouseScroll";
    EventListener["keydown"] = "keydown";
    EventListener["mousewheel"] = "mousewheel";
    EventListener["onwheel"] = "onwheel";
    EventListener["touchmove"] = "touchmove";
    EventListener["wheel"] = "wheel";
})(EventListener || (exports.EventListener = EventListener = {}));
function cancelEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
exports.cancelEvent = cancelEvent;
function getScrollParent(node) {
    if (!node) {
        return null;
    }
    if (node.scrollHeight > node.clientHeight) {
        return node;
    }
    else {
        return getScrollParent(node.parentNode);
    }
}
exports.getScrollParent = getScrollParent;
